export const addTicket = 'addTicket';
export const isAddTicketClicked = 'isaddTicketClicked';
export const isViewTicketClicked = "isViewTicketClicked";
export const viewTicketData = "viewTicketData";
export const viewTicketComments = "viewTicketComments";
export const newTicketComments = "newTicketComments";
export const viewTicketHistory = "viewTicketHistory"